import React from "react";
import Colors from "../../constants/Colors";
import ButtonComp from "../buttons/buttonComp/buttonComp";
import {useRouter} from 'next/router';

type IProps = {
    onClickFunction?: () => void;
    isRequested?: boolean;
};

const ContinueButton = ({
                            onClickFunction = () => {
                            },
                            isRequested = false
                        }: IProps) => {

    const navigation = useRouter();
    return (
        <ButtonComp backgroundColor={Colors.brandColor} visible={false} fullWidth={true} textColor={true}
                    uppercase={true} onClick={() => {
            if (isRequested) {
                navigation.back();
            } else {
                onClickFunction();
            }
        }}>
            {isRequested ? 'Geri Dön' : 'Devam'}
        </ButtonComp>
    );
};

export default ContinueButton;
